var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-footer"},[_c('deck-kbd',{attrs:{"command":"up down","label":_vm.$t('arrowKeys')}}),_vm._v(" "),_c('deck-kbd',{attrs:{"command":"enter","label":_vm.$t('enterKey')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }